function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_39687"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5041"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_1488"
}, /*#__PURE__*/React.createElement("circle", {
  id: "Ellipse_1_copy_12",
  cx: 17.5,
  cy: 17.5,
  r: 17.5,
  fill: "#f5f8fc"
})), /*#__PURE__*/React.createElement("g", {
  id: "Group_5030"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5003"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5029"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_5031"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4998"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4997"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_8856",
  d: "m17.91,6.21h-9.47c-.24,0-.44.2-.44.44h0v20.51c.15-.02.29-.02.44-.02h9.91V6.66c0-.24-.2-.44-.44-.44Zm-5.55,16.57h-2.15v-2.15h2.15v2.15Zm0-3.86h-2.15v-2.15h2.15v2.15Zm0-3.86h-2.15v-2.15h2.15v2.15Zm0-3.86h-2.15v-2.15h2.15v2.15Zm3.78,11.59h-2.14v-2.15h2.14v2.15Zm0-3.86h-2.14v-2.15h2.14v2.15Zm0-3.86h-2.14v-2.15h2.14v2.15Zm0-3.86h-2.14v-2.15h2.14v2.15Z",
  fill: "#808cac"
}))), /*#__PURE__*/React.createElement("g", {
  id: "Group_5000"
}, /*#__PURE__*/React.createElement("g", {
  id: "Group_4999"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_8857",
  d: "m28.44,12.32h-8.36v14.8h1.51v-6.76h5.69v6.78h1.16c.15,0,.3,0,.44.02v-14.4c0-.24-.2-.44-.44-.44h0Zm-4.83,5.09h-2.15v-2.15h2.15v2.15Zm3.78,0h-2.14v-2.15h2.14v2.15Z",
  fill: "#808cac"
}))))), /*#__PURE__*/React.createElement("path", {
  id: "Intersection_5",
  d: "m3.4,27.87h28.2c-3.3,4.49-8.53,7.13-14.1,7.13-5.57,0-10.8-2.64-14.1-7.13Z",
  fill: "#808cac"
})))));

var SvgBusinessProfileGrey = function SvgBusinessProfileGrey(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 35 35",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgBusinessProfileGrey, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/business-profile-grey.c632247b.svg";
export { ForwardRef as ReactComponent };